import { jsx as e, jsxs as a, Fragment as S } from "@emotion/react/jsx-runtime";
import { useRef as ee } from "react";
import z from "react-datepicker";
import "react-datepicker/dist/react-datepicker.min.css";
import { Calendar as te } from "./Calendar/Calendar.js";
import { CalendarHeader as re } from "./CalendarHeader/CalendarHeader.js";
import { DatePickerWrapperComponent as ne, DateInputFieldContainer as I, DatepickerCalendarWrapper as L, DayPickerSelected as ae } from "./DatePicker.styled.js";
import { DatePickerProvider as oe, useDatePickerContext as ce } from "./DatePickerContext.js";
import { DEFAULT_LOCALE as ie, buildShortcutItems as se, DEFAULT_MONTH_FORMAT as le, DEFAULT_MONTH_LABEL as de, DEFAULT_RANGE_DATE_PLACEHOLDERS as ue, DEFAULT_DATE_LABEL as De, updateRangeStart as he, updateRangeEnd as me } from "./helpers.js";
import { DateInputField as J } from "./Input/DateInputField.js";
import { DateRangeInputField as K } from "./Input/DateRangeInputField.js";
import { Shortcut as F } from "./Shortcut/Shortcut.js";
import { useClickOutside as pe } from "../../hooks/useClickOutside.js";
import { DatePickerType as w, DatePickerInputName as B } from "../../types/components/dateRangePicker.js";
const _ = z.default ?? z, fe = ({
  labels: d,
  placeholders: o,
  shortcutItems: M,
  disabled: c = !1,
  excludeDates: U = [],
  required: v = !1,
  onCloseCalendar: H
}) => {
  const i = ee(null), {
    dates: r,
    displayCalendar: s,
    setDisplayCalendar: u,
    onChange: l,
    datePickerType: C,
    withShortcut: D,
    minDate: x,
    maxDate: O,
    position: h,
    setActiveShortcut: g,
    localeDatePicker: y,
    activeInput: k,
    setActiveInput: m,
    previousDates: Y,
    setPreviousDates: P,
    refStartDate: Q,
    refEndDate: V,
    refContainer: f,
    calendarHeight: E
  } = ce(), X = (t, n) => {
    const R = (j) => {
      const p = r?.[j];
      return p && p.getDate() === t && p.getUTCMonth() === n.getUTCMonth() && p.getUTCFullYear() === n.getUTCFullYear();
    }, N = R(0), b = R(1);
    return N || b ? /* @__PURE__ */ e(ae, { children: t }) : /* @__PURE__ */ e("span", { children: t });
  }, T = M ?? se(C);
  pe({
    refs: [f, i],
    onClickOutside: () => {
      Q.current?.focus(), V.current?.focus(), H?.(), u(!1), m(null);
    },
    enabled: s === !0
  });
  const A = () => ({
    required: v,
    disabled: c,
    locale: y.name,
    calendarContainer: te,
    renderDayContents: (t, n) => X(t, n),
    renderCustomHeader: ({
      date: t,
      changeMonth: n,
      changeYear: R,
      decreaseMonth: N,
      increaseMonth: b,
      prevMonthButtonDisabled: j,
      nextMonthButtonDisabled: p
    }) => /* @__PURE__ */ e(re, { date: t, changeMonth: n, changeYear: R, decreaseMonth: N, increaseMonth: b, prevMonthButtonDisabled: j, nextMonthButtonDisabled: p }),
    inline: !0,
    minDate: x,
    maxDate: O,
    excludeDates: U
  }), W = (t) => {
    l && (l([t, null]), g(null));
  }, Z = (t, n) => {
    he(t, P, n, m);
  }, $ = (t, n) => {
    me(t, Y, P, n, m);
  }, G = (t) => {
    l && (k === B.StartDate ? Z(t, l) : k === B.EndDate && $(t, l), g(null));
  }, q = () => {
    u(!0), m(B.StartDate);
  };
  switch (C) {
    case w.DateSelector:
      return /* @__PURE__ */ a(S, { children: [
        /* @__PURE__ */ e(I, { ref: i, onClick: () => u(!0), "aria-disabled": c, children: /* @__PURE__ */ e(J, { label: d?.startDate ?? De, placeholder: o?.startDate ?? ue.startDate }) }),
        s && /* @__PURE__ */ a(L, { ref: f, position: h, calendarHeight: E, children: [
          D && /* @__PURE__ */ e(F, { shortcutItems: T }),
          /* @__PURE__ */ e(_, { selected: r?.[0], showMonthDropdown: !0, showYearDropdown: !0, fixedHeight: !0, dropdownMode: "select", onChange: W, ...A() })
        ] })
      ] });
    case w.MonthSelector:
      return /* @__PURE__ */ a(S, { children: [
        /* @__PURE__ */ e(I, { ref: i, onClick: () => u(!0), "aria-disabled": c, children: /* @__PURE__ */ e(J, { label: d?.startDate ?? de, placeholder: o?.startDate ?? le }) }),
        s && /* @__PURE__ */ a(L, { ref: f, position: h, calendarHeight: E, children: [
          D && /* @__PURE__ */ e(F, { shortcutItems: T }),
          /* @__PURE__ */ e(_, { selected: r?.[0], showMonthYearPicker: !0, onChange: W, ...A() })
        ] })
      ] });
    case w.DateRangePicker:
      return /* @__PURE__ */ a(S, { children: [
        /* @__PURE__ */ e(I, { ref: i, "aria-disabled": c, onClick: q, children: /* @__PURE__ */ e(K, { labels: d, placeholders: o }) }),
        s && /* @__PURE__ */ a(L, { ref: f, position: h, calendarHeight: E, children: [
          D && /* @__PURE__ */ e(F, { shortcutItems: T }),
          /* @__PURE__ */ e(_, { selectsRange: !0, startDate: r?.[0], endDate: r?.[1], onChange: G, ...A() })
        ] })
      ] });
    case w.MonthRangePicker:
      return /* @__PURE__ */ a(S, { children: [
        /* @__PURE__ */ e(I, { ref: i, "aria-disabled": c, onClick: q, children: /* @__PURE__ */ e(K, { labels: d, placeholders: o }) }),
        s && /* @__PURE__ */ a(L, { ref: f, position: h, calendarHeight: E, children: [
          D && /* @__PURE__ */ e(F, { shortcutItems: T }),
          /* @__PURE__ */ e(_, { onChange: G, showMonthYearPicker: !0, selectsRange: !0, startDate: r?.[0] ? r?.[0] : /* @__PURE__ */ new Date(), endDate: r?.[1], ...A() })
        ] })
      ] });
    default:
      return null;
  }
}, Me = ({
  dataTrackId: d,
  type: o,
  dates: M,
  format: c,
  onChange: U,
  withShortcut: v = !1,
  shortcuts: H,
  labels: i,
  placeholders: r,
  minDate: s,
  maxDate: u,
  disabled: l,
  excludeDates: C,
  required: D,
  position: x = "bottom-left",
  localeDatePicker: O = ie,
  full: h,
  error: g,
  warning: y,
  success: k,
  notice: m,
  isReset: Y,
  onCloseCalendar: P
}) => /* @__PURE__ */ e(oe, { dataTrackId: d, datePickerType: o, dates: M, format: c, localeDatePicker: O, onChange: U, withShortcut: v, minDate: s, maxDate: u, position: x, error: g, warning: y, success: k, notice: m, isReset: Y, children: /* @__PURE__ */ e(ne, { full: h, type: o, children: /* @__PURE__ */ e(fe, { labels: i, placeholders: r, excludeDates: C, disabled: l, required: D, shortcutItems: H, onCloseCalendar: P }) }) });
export {
  Me as OverrideDatePicker
};
